module.exports = __webpack_public_path__ + "img/template_blue.012ea73c.svg";